// src/services/trainingArticleServices.js
import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/training-articles`;
const token = localStorage.getItem("token");

/// GET
// Récupérer tous les articles (optionnel: category=DIRIGEANTS|CERTIF_ASSO & published=1|0)
export const getTrainingArticles = async (params = {}) => {
  try {
    const response = await axios.get(`${apiUrl}`, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des articles de formation:", error);
    return [];
  }
};

// Récupérer un article par id
export const getTrainingArticleById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement de l'article:", error);
    return null;
  }
};

/// POST
// Créer un article
export const createTrainingArticle = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la création de l'article:", error);
    throw error;
  }
};

/// PUT
// Mettre à jour un article
export const updateTrainingArticle = async (id, payload) => {
  try {
    const response = await axios.put(`${apiUrl}/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification de l'article:", error);
    throw error;
  }
};

/// PATCH
// Publier / dépublier un article
export const toggleTrainingArticlePublished = async (id, is_published) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/${id}/publish`,
      { is_published },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors du changement de publication:", error);
    throw error;
  }
};

// Upload d'une photo (slot 1..3)
export const updateTrainingArticlePhoto = async (id, slot, file, tokenOverride) => {
  const formData = new FormData();
  formData.append("image", file);

  const authToken = tokenOverride || token;

  try {
    const response = await axios.patch(
      `${apiUrl}/${id}/photo/${slot}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
    if (response.status !== 200) throw new Error("Failed to update photo");
    return response.data; // { slot, imageUrl }
  } catch (error) {
    console.error("Erreur lors de la mise à jour de la photo:", error);
    return "";
  }
};

/// DELETE
// Supprimer un article
export const deleteTrainingArticle = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // { ok: true }
  } catch (error) {
    console.error("Erreur lors de la suppression de l'article:", error);
    throw error;
  }
};
